import { IUrlJsonObjectVM } from "../models";
import { CryptoManagerService } from "./crypto-manager.service";

export class UrlDataBuilder {
    jsonObj: IUrlJsonObjectVM = { pId: 0, enId: 0 };

    constructor(private cryptoManagerService: CryptoManagerService) { }

    setPatientId = (patientId: number | null | undefined): UrlDataBuilder => {
        this.jsonObj.pId = patientId || 0;
        return this;
    }

    setEncounterId = (encounterId: number | null | undefined): UrlDataBuilder => {
        this.jsonObj.enId = encounterId || 0;
        return this;
    }

    getEncryptedUrlData = (): string => {
        const model: any = {};

        Object.keys(this.jsonObj)
            .forEach(key => {
                if (this.jsonObj[key as keyof IUrlJsonObjectVM] > 0)
                    model[key] = this.jsonObj[key as keyof IUrlJsonObjectVM];
            });

        return this.cryptoManagerService.getBase64UrlFromObject(model);
    }
}
